module.exports = __webpack_public_path__ + "static/media/printer-image.617f8cf7.png";